import useGoogleAnalytics from './private/useGoogleAnalytics';

const useCommmonEvents = () => {
  const publisher = useGoogleAnalytics();
  const publishClick = (text: string, location?: string) => {
    void publisher.actions.publishClick(text, location);
  };
  const publishLanguageChange = (language: string) => {
    void publisher.actions.publishLanguageChange(language);
  };

  const publishCloseCookieBanner = async () => {
    void publisher.actions.publishCloseCookieBanner();
  };

  return {
    actions: {
      publishClick,
      publishLanguageChange,
      publishCloseCookieBanner,
      publishOpenDevPanel: publisher.actions.publishOpenDevPanel,
    },
  };
};

export default useCommmonEvents;
